import { T } from "@supersig/validate";
import { cssTypeMap } from "./css";
import { variableTypeMap } from "./variables";
import { propertyTypeMap } from "./properties";
export const literalValueTypes = T.union("type", {
    ...variableTypeMap,
    ...cssTypeMap,
    ...propertyTypeMap
});
export const literalTypeNames = [
    ...Object.keys(cssTypeMap),
    ...Object.keys(variableTypeMap),
    ...Object.keys(propertyTypeMap)
];
export const literalValueTypeNameValidator = T.literalEnum(...Object.keys(variableTypeMap), ...Object.keys(cssTypeMap), ...Object.keys(propertyTypeMap));
export const valueTypeMap = {
    "value-type": T.object({
        type: T.literal("value-type"),
        value: literalValueTypeNameValidator
    })
};
export const literalTypeValuesAndTypeValue = T.union("type", {
    ...variableTypeMap,
    ...cssTypeMap,
    ...propertyTypeMap,
    ...valueTypeMap
});
export * from "./css";
export * from "./variables";
export * from "./properties";
export * from "./resource"; // Editing configs
